<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<mat-card appearance="raised" style="padding: 5px 0; height: 100%;">
    <div>
        <span>
            <p class="component-label">
                <span class="draggable">{{fProtections}}</span>
                <span tabindex="0" attr.aria-label="{{fProtectionsInfo}}" matTooltip="{{fProtectionsInfo}}"
                    matTooltipPosition="right">
                    <span class="mdi mdi-information-outline info-icon"></span>
                </span>
            </p>
        </span>
        <hr>
        <div *ngIf="dashboardConfigLoaded">
            <span class="dashboard-config-loaded"></span>
        </div>
    </div>
    <div class="icon-and-list" style="height: 200px;">
        <div class="icon-area-config">
          <ngx-charts-gauge
              [showAxis]="showAxis"
              [scheme]="colorScheme"
              [showText]="showText"
              [view]="view"
              [results]="data"
              [legend]="legend"
              [legendPosition]="legendPosition"
              [max]="totalDevices"
              [bigSegments]="bigSegments"
              smallSegments=0
              [margin]="margin">
           </ngx-charts-gauge>
        </div>
        <div class="list-area-config">
          <ul>
            <li class="list-item" *ngFor="let d of data; let i = index">
                <div class="list-info">
                <span id="configSection-{{i}}" title="{{d['name']}}" class="item-label">{{ d['name'] }}</span>
                <span *ngIf="!(loadingConfig$ | async); else loadingNoProtection;" [ngStyle]="{'color': getColors(d)}" class="item-value" attr.aria-label="{{d['name']}} {{ d['value'] }}" id="{{d['name']}}">{{ d['value'] }}</span>
                <ng-template #loadingNoProtection>
                    <ngx-skeleton-loader
                      count="1"
                      appearance="line"
                      [theme]="valueStyle">
                    </ngx-skeleton-loader>
                </ng-template>
                </div>
            </li>
          </ul>
        </div>
    </div>
    <div class="component-footnote">
        <span>{{fProtectionsNote}}</span>
    </div>
</mat-card>